import React from 'react'
import { Link, useNavigate } from 'react-router-dom'

const Header = (props) => {
    const navigate = useNavigate();

    return (
        <div className='bg-white/60 border-b border-purple-800/20 px-2 py-1 text-purple-700 relative flex items-center'>
            <button onClick={() => navigate(-1)} className='rounded-lg hover:bg-gray-300/30 px-2 py-1'><i className='bi bi-chevron-left text-2xl'></i></button>

            <Link to="/" className='max-w-3xl mx-auto text-xl tracking-widest'>電鬼2</Link>

            {/* ユーザ名 */}
            <Link to={props.userData.username ? "/account" : "/signIn"} className='text-gray-700 text-lg rounded-full py-1.5 px-4 cursor-pointer hover:bg-purple-800/10'>
                {props.userData.username ? (
                    <span><i className='me-1 bi bi-person-fill text-purple-800/50'></i>{props.userData.username}</span>
                ) : "サインイン"}
            </Link>
        </div>
    )
}

export default Header